export const BANGLADESH_CITIES = [
  { id: 'dhaka', nameen: 'Dhaka', namebn: 'ঢাকা' },
  { id: 'faridpur', nameen: 'Faridpur', namebn: 'ফরিদপুর' },
  { id: 'gazipur', nameen: 'Gazipur', namebn: 'গাজীপুর' },
  { id: 'gopalganj', nameen: 'Gopalganj', namebn: 'গোপালগঞ্জ' },
  { id: 'kishoreganj', nameen: 'Kishoreganj', namebn: 'কিশোরগঞ্জ' },
  { id: 'madaripur', nameen: 'Madaripur', namebn: 'মাদারীপুর' },
  { id: 'manikganj', nameen: 'Manikganj', namebn: 'মানিকগঞ্জ' },
  { id: 'munshiganj', nameen: 'Munshiganj', namebn: 'মুন্সীগঞ্জ' },
  { id: 'narayanganj', nameen: 'Narayanganj', namebn: 'নারায়ণগঞ্জ' },
  { id: 'narsingdi', nameen: 'Narsingdi', namebn: 'নরসিংদী' },
  { id: 'rajbari', nameen: 'Rajbari', namebn: 'রাজবাড়ী' },
  { id: 'shariatpur', nameen: 'Shariatpur', namebn: 'শরিয়তপুর' },
  { id: 'tangail', nameen: 'Tangail', namebn: 'টাঙ্গাইল' },
  { id: 'bogra', nameen: 'Bogra', namebn: 'বগুড়া' },
  { id: 'joypurhat', nameen: 'Joypurhat', namebn: 'জয়পুরহাট' },
  { id: 'naogaon', nameen: 'Naogaon', namebn: 'নওগাঁ' },
  { id: 'natore', nameen: 'Natore', namebn: 'নাটোর' },
  { id: 'nawabganj', nameen: 'Nawabganj', namebn: 'নবাবগঞ্জ' },
  { id: 'pabna', nameen: 'Pabna', namebn: 'পাবনা' },
  { id: 'rajshahi', nameen: 'Rajshahi', namebn: 'রাজশাহী' },
  { id: 'sirajgonj', nameen: 'Sirajgonj', namebn: 'সিরাজগঞ্জ' },
  { id: 'dinajpur', nameen: 'Dinajpur', namebn: 'দিনাজপুর' },
  { id: 'gaibandha', nameen: 'Gaibandha', namebn: 'গাইবান্ধা' },
  { id: 'kurigram', nameen: 'Kurigram', namebn: 'কুড়িগ্রাম' },
  { id: 'lalmonirhat', nameen: 'Lalmonirhat', namebn: 'লালমনিরহাট' },
  { id: 'nilphamari', nameen: 'Nilphamari', namebn: 'নীলফামারী' },
  { id: 'panchagarh', nameen: 'Panchagarh', namebn: 'পঞ্চগড়' },
  { id: 'rangpur', nameen: 'Rangpur', namebn: 'রংপুর' },
  { id: 'thakurgaon', nameen: 'Thakurgaon', namebn: 'ঠাকুরগাঁও' },
  { id: 'barguna', nameen: 'Barguna', namebn: 'বরগুনা' },
  { id: 'barishal', nameen: 'Barishal', namebn: 'বরিশাল' },
  { id: 'bhola', nameen: 'Bhola', namebn: 'ভোলা' },
  { id: 'jhalokati', nameen: 'Jhalokati', namebn: 'ঝালকাঠি' },
  { id: 'patuakhali', nameen: 'Patuakhali', namebn: 'পটুয়াখালী' },
  { id: 'pirojpur', nameen: 'Pirojpur', namebn: 'পিরোজপুর' },
  { id: 'bandarban', nameen: 'Bandarban', namebn: 'বান্দরবান' },
  { id: 'brahmanbaria', nameen: 'Brahmanbaria', namebn: 'ব্রাহ্মণবাড়িয়া' },
  { id: 'chandpur', nameen: 'Chandpur', namebn: 'চাঁদপুর' },
  { id: 'chattogram', nameen: 'Chattogram', namebn: 'চট্টগ্রাম' },
  { id: 'comilla', nameen: 'Comilla', namebn: 'কুমিল্লা' },
  { id: 'coxs_bazar', nameen: 'Cox\'s Bazar', namebn: 'কক্সবাজার' },
  { id: 'feni', nameen: 'Feni', namebn: 'ফেনী' },
  { id: 'khagrachari', nameen: 'Khagrachari', namebn: 'খাগড়াছড়ি' },
  { id: 'lakshmipur', nameen: 'Lakshmipur', namebn: 'লক্ষ্মীপুর' },
  { id: 'noakhali', nameen: 'Noakhali', namebn: 'নোয়াখালী' },
  { id: 'rangamati', nameen: 'Rangamati', namebn: 'রাঙ্গামাটি' },
  { id: 'habiganj', nameen: 'Habiganj', namebn: 'হবিগঞ্জ' },
  { id: 'moulvibazar', nameen: 'Moulvibazar', namebn: 'মৌলভীবাজার' },
  { id: 'sunamganj', nameen: 'Sunamganj', namebn: 'সুনামগঞ্জ' },
  { id: 'sylhet', nameen: 'Sylhet', namebn: 'সিলেট' },
  { id: 'bagerhat', nameen: 'Bagerhat', namebn: 'বাগেরহাট' },
  { id: 'chuadanga', nameen: 'Chuadanga', namebn: 'চুয়াডাঙ্গা' },
  { id: 'jessore', nameen: 'Jessore', namebn: 'যশোর' },
  { id: 'jhenaidah', nameen: 'Jhenaidah', namebn: 'ঝিনাইদহ' },
  { id: 'khulna', nameen: 'Khulna', namebn: 'খুলনা' },
  { id: 'kushtia', nameen: 'Kushtia', namebn: 'কুষ্টিয়া' },
  { id: 'magura', nameen: 'Magura', namebn: 'মাগুরা' },
  { id: 'meherpur', nameen: 'Meherpur', namebn: 'মেহেরপুর' },
  { id: 'narail', nameen: 'Narail', namebn: 'নড়াইল' },
  { id: 'satkhira', nameen: 'Satkhira', namebn: 'সাতক্ষীরা' },
  { id: 'jamalpur', nameen: 'Jamalpur', namebn: 'জামালপুর' },
  { id: 'mymensingh', nameen: 'Mymensingh', namebn: 'ময়মনসিংহ' },
  { id: 'netrokona', nameen: 'Netrokona', namebn: 'নেত্রকোনা' },
  { id: 'sherpur', nameen: 'Sherpur', namebn: 'শেরপুর' }
].sort((a, b) => a.nameen.localeCompare(b.nameen));

export const CITY_AREAS: Record<string, { id: string; nameen: string; namebn: string }[]> = {
  'Dhaka': [
    { id: 'uttara', nameen: 'Uttara', namebn: 'উত্তরা' },
    { id: 'mirpur', nameen: 'Mirpur', namebn: 'মিরপুর' },
    { id: 'gulshan', nameen: 'Gulshan', namebn: 'গুলশান' },
    { id: 'banani', nameen: 'Banani', namebn: 'বনানী' },
    { id: 'dhanmondi', nameen: 'Dhanmondi', namebn: 'ধানমন্ডি' },
    { id: 'badda', nameen: 'Badda', namebn: 'বাড্ডা' },
    { id: 'mohammadpur', nameen: 'Mohammadpur', namebn: 'মোহাম্মদপুর' },
    { id: 'motijheel', nameen: 'Motijheel', namebn: 'মতিঝিল' },
    { id: 'jatrabari', nameen: 'Jatrabari', namebn: 'যাত্রাবাড়ী' },
    { id: 'khilgaon', nameen: 'Khilgaon', namebn: 'খিলগাঁও' },
    { id: 'rampur', nameen: 'Rampura', namebn: 'রামপুরা' },
    { id: 'malibagh', nameen: 'Malibagh', namebn: 'মালিবাগ' },
    { id: 'basundhara', nameen: 'Bashundhara', namebn: 'বসুন্ধরা' },
    { id: 'tejgaon', nameen: 'Tejgaon', namebn: 'তেজগাঁও' },
    { id: 'savar', nameen: 'Savar', namebn: 'সাভার' },
    { id: 'keraniganj', nameen: 'Keraniganj', namebn: 'কেরানীগঞ্জ' },
    { id: 'faridgate', nameen: 'Farmgate', namebn: 'ফার্মগেট' },
    { id: 'pallabi', nameen: 'Pallabi', namebn: 'পল্লবী' }
  ],
  'Chattogram': [
    { id: 'agrabad', nameen: 'Agrabad', namebn: 'আগ্রাবাদ' },
    { id: 'pahartali', nameen: 'Pahartali', namebn: 'পাহাড়তলী' },
    { id: 'halishahar', nameen: 'Halishahar', namebn: 'হালিশহর' },
    { id: 'patenga', nameen: 'Patenga', namebn: 'পতেঙ্গা' },
    { id: 'khulshi', nameen: 'Khulshi', namebn: 'খুলশী' },
    { id: 'kotwali', nameen: 'Kotwali', namebn: 'কোতোয়ালী' },
    { id: 'bakalia', nameen: 'Bakalia', namebn: 'বাকলিয়া' },
    { id: 'chandgaon', nameen: 'Chandgaon', namebn: 'চান্দগাঁও' },
    { id: 'sitakunda', nameen: 'Sitakunda', namebn: 'সীতাকুণ্ড' },
    { id: 'gec', nameen: 'GEC Circle', namebn: 'জিইসি মোড়' }
  ],
  'Sylhet': [
    { id: 'zindabazar', nameen: 'Zindabazar', namebn: 'জিন্দাবাজার' },
    { id: 'bandarbazar', nameen: 'Bandarbazar', namebn: 'বন্দরবাজার' },
    { id: 'subidbazar', nameen: 'Subidbazar', namebn: 'সুবিদবাজার' },
    { id: 'ambarkhana', nameen: 'Ambarkhana', namebn: 'আম্বরখানা' },
    { id: 'shibganj', nameen: 'Shibganj', namebn: 'শিবগঞ্জ' },
    { id: 'south_surma', nameen: 'South Surma', namebn: 'দক্ষিণ সুরমা' },
    { id: 'upshahar', nameen: 'Uposhahar', namebn: 'উপশহর' },
    { id: 'tultikor', nameen: 'Tultikor', namebn: 'টুলটিকর' }
  ],
  'Rajshahi': [
    { id: 'shaheb_bazar', nameen: 'Shaheb Bazar', namebn: 'সাহেব বাজার' },
    { id: 'motihar', nameen: 'Motihar', namebn: 'মতিহার' },
    { id: 'boalia', nameen: 'Boalia', namebn: 'বোয়ালিয়া' },
    { id: 'rajpara', nameen: 'Rajpara', namebn: 'রাজপাড়া' },
    { id: 'paba', nameen: 'Paba', namebn: 'পবা' },
    { id: 'shah_makhdum', nameen: 'Shah Makhdum', namebn: 'শাহ মখদুম' }
  ],
  'Khulna': [
    { id: 'sonadanga', nameen: 'Sonadanga', namebn: 'সোনাডাঙ্গা' },
    { id: 'khalishpur', nameen: 'Khalishpur', namebn: 'খালিশপুর' },
    { id: 'daulatpur', nameen: 'Daulatpur', namebn: 'দৌলতপুর' },
    { id: 'khulna_sadar', nameen: 'Khulna Sadar', namebn: 'খুলনা সদর' },
    { id: 'khan_jahan_ali', nameen: 'Khan Jahan Ali', namebn: 'খান জাহান আলী' }
  ],
  'Barishal': [
    { id: 'sadar', nameen: 'Barishal Sadar', namebn: 'বরিশাল সদর' },
    { id: 'rupatali', nameen: 'Rupatali', namebn: 'রূপাতলী' },
    { id: 'nathullabad', nameen: 'Nathullabad', namebn: 'নথুল্লাবাদ' },
    { id: 'bakerganj', nameen: 'Bakerganj', namebn: 'বাকেরগঞ্জ' },
    { id: 'uzirpur', nameen: 'Uzirpur', namebn: 'উজিরপুর' }
  ],
  'Rangpur': [
    { id: 'sadar', nameen: 'Rangpur Sadar', namebn: 'রংপুর সদর' },
    { id: 'tajhat', nameen: 'Tajhat', namebn: 'তাজহাট' },
    { id: 'mithapukur', nameen: 'Mithapukur', namebn: 'মিঠাপুকুর' },
    { id: 'pirganj', nameen: 'Pirganj', namebn: 'পীরগঞ্জ' }
  ],
  'Mymensingh': [
    { id: 'sadar', nameen: 'Mymensingh Sadar', namebn: 'ময়মনসিংহ সদর' },
    { id: 'bhaluka', nameen: 'Bhaluka', namebn: 'ভালুকা' },
    { id: 'muktagacha', nameen: 'Muktagacha', namebn: 'মুক্তাগাছা' },
    { id: 'trishal', nameen: 'Trishal', namebn: 'ত্রিশাল' }
  ],
  'Comilla': [
    { id: 'sadar', nameen: 'Comilla Sadar', namebn: 'কুমিল্লা সদর' },
    { id: 'kandirpar', nameen: 'Kandirpar', namebn: 'কান্দিরপাড়' },
    { id: 'burichang', nameen: 'Burichang', namebn: 'বুড়িচং' },
    { id: 'chauddagram', nameen: 'Chauddagram', namebn: 'চৌদ্দগ্রাম' },
    { id: 'laksam', nameen: 'Laksam', namebn: 'লাকসাম' },
    { id: 'barura', nameen: 'Barura', namebn: 'বরুড়া' }
  ],
  'Gazipur': [
    { id: 'tongi', nameen: 'Tongi', namebn: 'টঙ্গী' },
    { id: 'konabari', nameen: 'Konabari', namebn: 'কোনাবাড়ী' },
    { id: 'board_bazar', nameen: 'Board Bazar', namebn: 'বোর্ড বাজার' },
    { id: 'joydebpur', nameen: 'Joydebpur', namebn: 'জয়দেবপুর' },
    { id: 'kaliakair', nameen: 'Kaliakair', namebn: 'কালিয়াকৈর' },
    { id: 'kapasia', nameen: 'Kapasia', namebn: 'কাপাসিয়া' },
    { id: 'sripur', nameen: 'Sripur', namebn: 'শ্রীপুর' }
  ],
  'Narayanganj': [
    { id: 'chashara', nameen: 'Chashara', namebn: 'চাষাঢ়া' },
    { id: 'fatullah', nameen: 'Fatullah', namebn: 'ফতুল্লা' },
    { id: 'siddhirganj', nameen: 'Siddhirganj', namebn: 'সিদ্ধিরগঞ্জ' },
    { id: 'rupganj', nameen: 'Rupganj', namebn: 'রূপগঞ্জ' },
    { id: 'sonargaon', nameen: 'Sonargaon', namebn: 'সোনারগাঁও' },
    { id: 'bandar', nameen: 'Bandar', namebn: 'বন্দর' }
  ],

  // newly added district areas
  'Faridpur': [
    { id: 'faridpur_sadar', nameen: 'Faridpur Sadar', namebn: 'ফরিদপুর সদর' },
    { id: 'boalmari', nameen: 'Boalmari', namebn: 'বোয়ালমারী' },
    { id: 'alfadanga', nameen: 'Alfadanga', namebn: 'আলফাডাঙ্গা' }
  ],
  'Gopalganj': [
    { id: 'gopalganj_sadar', nameen: 'Gopalganj Sadar', namebn: 'গোপালগঞ্জ সদর' },
    { id: 'kashiani', nameen: 'Kashiani', namebn: 'কাশিয়ানী' }
  ],
  'Kishoreganj': [
    { id: 'kishoreganj_sadar', nameen: 'Kishoreganj Sadar', namebn: 'কিশোরগঞ্জ সদর' },
    { id: 'bhairab', nameen: 'Bhairab', namebn: 'ভৈরব' },
    { id: 'bajitpur', nameen: 'Bajitpur', namebn: 'বাজিতপুর' }
  ],
  'Madaripur': [
    { id: 'madaripur_sadar', nameen: 'Madaripur Sadar', namebn: 'মাদারীপুর সদর' },
    { id: 'shibchar', nameen: 'Shibchar', namebn: 'শিবচর' }
  ],
  'Manikganj': [
    { id: 'manikganj_sadar', nameen: 'Manikganj Sadar', namebn: 'মানিকগঞ্জ সদর' },
    { id: 'saturia', nameen: 'Saturia', namebn: 'সাটুরিয়া' }
  ],
  'Munshiganj': [
    { id: 'munshiganj_sadar', nameen: 'Munshiganj Sadar', namebn: 'মুন্সীগঞ্জ সদর' },
    { id: 'sirajdikhan', nameen: 'Sirajdikhan', namebn: 'সিরাজদিখান' },
    { id: 'sreenagar', nameen: 'Sreenagar', namebn: 'শ্রীনগর' }
  ],
  'Narsingdi': [
    { id: 'narsingdi_sadar', nameen: 'Narsingdi Sadar', namebn: 'নরসিংদী সদর' },
    { id: 'shibpur', nameen: 'Shibpur', namebn: 'শিবপুর' }
  ],
  'Rajbari': [
    { id: 'rajbari_sadar', nameen: 'Rajbari Sadar', namebn: 'রাজবাড়ী সদর' },
    { id: 'goalanda', nameen: 'Goalanda', namebn: 'গোয়ালন্দ' }
  ],
  'Shariatpur': [
    { id: 'shariatpur_sadar', nameen: 'Shariatpur Sadar', namebn: 'শরিয়তপুর সদর' },
    { id: 'naria', nameen: 'Naria', namebn: 'নড়িয়া' }
  ],
  'Tangail': [
    { id: 'tangail_sadar', nameen: 'Tangail Sadar', namebn: 'টাঙ্গাইল সদর' },
    { id: 'mirzapur', nameen: 'Mirzapur', namebn: 'মির্জাপুর' },
    { id: 'ghatail', nameen: 'Ghatail', namebn: 'ঘাটাইল' }
  ],
  'Bogra': [
    { id: 'bogra_sadar', nameen: 'Bogra Sadar', namebn: 'বগুড়া সদর' },
    { id: 'shibganj_bogra', nameen: 'Shibganj', namebn: 'শিবগঞ্জ' }
  ],
  'Joypurhat': [
    { id: 'joypurhat_sadar', nameen: 'Joypurhat Sadar', namebn: 'জয়পুরহাট সদর' },
    { id: 'panchbibi', nameen: 'Panchbibi', namebn: 'পাঁচবিবি' }
  ],
  'Naogaon': [
    { id: 'naogaon_sadar', nameen: 'Naogaon Sadar', namebn: 'নওগাঁ সদর' },
    { id: 'niamatpur', nameen: 'Niamatpur', namebn: 'নিয়ামতপুর' }
  ],
  'Natore': [
    { id: 'natore_sadar', nameen: 'Natore Sadar', namebn: 'নাটোর সদর' },
    { id: 'singra', nameen: 'Singra', namebn: 'সিংড়া' }
  ],
  'Nawabganj': [
    { id: 'nawabganj_sadar', nameen: 'Nawabganj Sadar', namebn: 'নবাবগঞ্জ সদর' },
    { id: 'shibganj_nawabganj', nameen: 'Shibganj', namebn: 'শিবগঞ্জ' }
  ],
  'Pabna': [
    { id: 'pabna_sadar', nameen: 'Pabna Sadar', namebn: 'পাবনা সদর' },
    { id: 'ishwardi', nameen: 'Ishwardi', namebn: 'ঈশ্বরদী' }
  ],
  'Sirajgonj': [
    { id: 'sirajganj_sadar', nameen: 'Sirajganj Sadar', namebn: 'সিরাজগঞ্জ সদর' },
    { id: 'ullapara', nameen: 'Ullapara', namebn: 'উল্লাপাড়া' }
  ],
  'Dinajpur': [
    { id: 'dinajpur_sadar', nameen: 'Dinajpur Sadar', namebn: 'দিনাজপুর সদর' },
    { id: 'birganj', nameen: 'Birganj', namebn: 'বীরগঞ্জ' }
  ],
  'Gaibandha': [
    { id: 'gaibandha_sadar', nameen: 'Gaibandha Sadar', namebn: 'গাইবান্ধা সদর' },
    { id: 'gobindaganj', nameen: 'Gobindaganj', namebn: 'গোবিন্দগঞ্জ' }
  ],
  'Kurigram': [
    { id: 'kurigram_sadar', nameen: 'Kurigram Sadar', namebn: 'কুড়িগ্রাম সদর' },
    { id: 'bhurungamari', nameen: 'Bhurungamari', namebn: 'ভুরুঙ্গামারী' }
  ],
  'Lalmonirhat': [
    { id: 'lalmonirhat_sadar', nameen: 'Lalmonirhat Sadar', namebn: 'লালমনিরহাট সদর' },
    { id: 'patgram', nameen: 'Patgram', namebn: 'পাটগ্রাম' }
  ],
  'Nilphamari': [
    { id: 'nilphamari_sadar', nameen: 'Nilphamari Sadar', namebn: 'নীলফামারী সদর' },
    { id: 'saidpur', nameen: 'Saidpur', namebn: 'সৈয়দপুর' }
  ],
  'Panchagarh': [
    { id: 'panchagarh_sadar', nameen: 'Panchagarh Sadar', namebn: 'পঞ্চগড় সদর' },
    { id: 'tetulia', nameen: 'Tetulia', namebn: 'তেঁতুলিয়া' }
  ],
  'Thakurgaon': [
    { id: 'thakurgaon_sadar', nameen: 'Thakurgaon Sadar', namebn: 'ঠাকুরগাঁও সদর' },
    { id: 'pirganj_thakurgaon', nameen: 'Pirganj', namebn: 'পীরগঞ্জ' }
  ],
  'Barguna': [
    { id: 'barguna_sadar', nameen: 'Barguna Sadar', namebn: 'বরগুনা সদর' },
    { id: 'amtali', nameen: 'Amtali', namebn: 'আমতলী' }
  ],
  'Bhola': [
    { id: 'bhola_sadar', nameen: 'Bhola Sadar', namebn: 'ভোলা সদর' },
    { id: 'char_fasson', nameen: 'Char Fasson', namebn: 'চরফ্যাশন' }
  ],
  'Jhalokati': [
    { id: 'jhalokati_sadar', nameen: 'Jhalokati Sadar', namebn: 'ঝালকাঠি সদর' },
    { id: 'rajapur', nameen: 'Rajapur', namebn: 'রাজাপুর' }
  ],
  'Patuakhali': [
    { id: 'patuakhali_sadar', nameen: 'Patuakhali Sadar', namebn: 'পটুয়াখালী সদর' },
    { id: 'bauphal', nameen: 'Bauphal', namebn: 'বাউফল' }
  ],
  'Pirojpur': [
    { id: 'pirojpur_sadar', nameen: 'Pirojpur Sadar', namebn: 'পিরোজপুর সদর' },
    { id: 'mathbaria', nameen: 'Mathbaria', namebn: 'মঠবাড়ীয়া' }
  ],
  'Bandarban': [
    { id: 'bandarban_sadar', nameen: 'Bandarban Sadar', namebn: 'বান্দরবান সদর' },
    { id: 'thanchi', nameen: 'Thanchi', namebn: 'থানচি' }
  ],
  'Brahmanbaria': [
    { id: 'brahmanbaria_sadar', nameen: 'Brahmanbaria Sadar', namebn: 'ব্রাহ্মণবাড়িয়া সদর' },
    { id: 'ashuganj', nameen: 'Ashuganj', namebn: 'আশুগঞ্জ' }
  ],
  'Chandpur': [
    { id: 'chandpur_sadar', nameen: 'Chandpur Sadar', namebn: 'চাঁদপুর সদর' },
    { id: 'hajiganj', nameen: 'Hajiganj', namebn: 'হাজীগঞ্জ' }
  ],
  'Cox\'s Bazar': [
    { id: 'coxs_bazar_sadar', nameen: 'Cox\'s Bazar Sadar', namebn: 'কক্সবাজার সদর' },
    { id: 'ukhiya', nameen: 'Ukhiya', namebn: 'উখিয়া' }
  ],
  'Feni': [
    { id: 'feni_sadar', nameen: 'Feni Sadar', namebn: 'ফেনী সদর' },
    { id: 'daganbhuiyan', nameen: 'Daganbhuiyan', namebn: 'দাগনভূঞা' }
  ],
  'Khagrachari': [
    { id: 'khagrachari_sadar', nameen: 'Khagrachari Sadar', namebn: 'খাগড়াছড়ি সদর' },
    { id: 'dighinala', nameen: 'Dighinala', namebn: 'দীঘিনালা' }
  ],
  'Lakshmipur': [
    { id: 'lakshmipur_sadar', nameen: 'Lakshmipur Sadar', namebn: 'লক্ষ্মীপুর সদর' },
    { id: 'raipur', nameen: 'Raipur', namebn: 'রায়পুর' }
  ],
  'Noakhali': [
    { id: 'noakhali_sadar', nameen: 'Noakhali Sadar', namebn: 'নোয়াখালী সদর' },
    { id: 'begumganj', nameen: 'Begumganj', namebn: 'বেগমগঞ্জ' }
  ],
  'Rangamati': [
    { id: 'rangamati_sadar', nameen: 'Rangamati Sadar', namebn: 'রাঙ্গামাটি সদর' },
    { id: 'kaptai', nameen: 'Kaptai', namebn: 'কাপ্তাই' }
  ],
  'Habiganj': [
    { id: 'habiganj_sadar', nameen: 'Habiganj Sadar', namebn: 'হবিগঞ্জ সদর' },
    { id: 'chunarughat', nameen: 'Chunarughat', namebn: 'চুনারুঘাট' }
  ],
  'Moulvibazar': [
    { id: 'moulvibazar_sadar', nameen: 'Moulvibazar Sadar', namebn: 'মৌলভীবাজার সদর' },
    { id: 'sreemangal', nameen: 'Sreemangal', namebn: 'শ্রীমঙ্গল' }
  ],
  'Sunamganj': [
    { id: 'sunamganj_sadar', nameen: 'Sunamganj Sadar', namebn: 'সুনামগঞ্জ সদর' },
    { id: 'chhatak', nameen: 'Chhatak', namebn: 'ছাতক' }
  ],
  'Bagerhat': [
    { id: 'bagerhat_sadar', nameen: 'Bagerhat Sadar', namebn: 'বাগেরহাট সদর' },
    { id: 'fakirhat', nameen: 'Fakirhat', namebn: 'ফকিরহাট' }
  ],
  'Chuadanga': [
    { id: 'chuadanga_sadar', nameen: 'Chuadanga Sadar', namebn: 'চুয়াডাঙ্গা সদর' },
    { id: 'alamdanga', nameen: 'Alamdanga', namebn: 'আলমডাঙ্গা' }
  ],
  'Jessore': [
    { id: 'jessore_sadar', nameen: 'Jessore Sadar', namebn: 'যশোর সদর' },
    { id: 'abhaynagar', nameen: 'Abhaynagar', namebn: 'অভয়নগর' }
  ],
  'Jhenaidah': [
    { id: 'jhenaidah_sadar', nameen: 'Jhenaidah Sadar', namebn: 'ঝিনাইদহ সদর' },
    { id: 'shailkupa', nameen: 'Shailkupa', namebn: 'শৈলকুপা' }
  ],
  'Kushtia': [
    { id: 'kushtia_sadar', nameen: 'Kushtia Sadar', namebn: 'কুষ্টিয়া সদর' },
    { id: 'bheramara', nameen: 'Bheramara', namebn: 'ভেড়ামারা' }
  ],
  'Magura': [
    { id: 'magura_sadar', nameen: 'Magura Sadar', namebn: 'মাগুরা সদর' },
    { id: 'shalikha', nameen: 'Shalikha', namebn: 'শালিখা' }
  ],
  'Meherpur': [
    { id: 'meherpur_sadar', nameen: 'Meherpur Sadar', namebn: 'মেহেরপুর সদর' },
    { id: 'gangni', nameen: 'Gangni', namebn: 'গাংনী' }
  ],
  'Narail': [
    { id: 'narail_sadar', nameen: 'Narail Sadar', namebn: 'নড়াইল সদর' },
    { id: 'kalia', nameen: 'Kalia', namebn: 'কালিয়া' }
  ],
  'Satkhira': [
    { id: 'satkhira_sadar', nameen: 'Satkhira Sadar', namebn: 'সাতক্ষীরা সদর' },
    { id: 'tala', nameen: 'Tala', namebn: 'তালা' }
  ],
  'Jamalpur': [
    { id: 'jamalpur_sadar', nameen: 'Jamalpur Sadar', namebn: 'জামালপুর সদর' },
    { id: 'islampur', nameen: 'Islampur', namebn: 'ইসলামপুর' }
  ],
  'Netrokona': [
    { id: 'netrokona_sadar', nameen: 'Netrokona Sadar', namebn: 'নেত্রকোনা সদর' },
    { id: 'kendua', nameen: 'Kendua', namebn: 'কেন্দুয়া' }
  ],
  'Sherpur': [
    { id: 'sherpur_sadar', nameen: 'Sherpur Sadar', namebn: 'শেরপুর সদর' },
    { id: 'jhenaigati', nameen: 'Jhenaigati', namebn: 'ঝিনাইগাতী' }
  ]
};

export function getLocationName(name: string, lang: string): string {
  if (lang !== 'bn') return name;

  // Check city names
  const city = BANGLADESH_CITIES.find(c => c.nameen.toLowerCase() === name.toLowerCase());
  if (city) return city.namebn;

  // Check area names
  for (const areas of Object.values(CITY_AREAS)) {
    const area = areas.find(a => a.nameen.toLowerCase() === name.toLowerCase());
    if (area) return area.namebn;
  }

  return name;
}
